class ReviewsIoStoreStats extends HTMLElement {
	async connectedCallback() {
		if (!this.store) {
			return;
		}
		const options = {
			method: 'GET',
			headers: {
				'Accept-Language': 'de',
				accept: 'application/json',
			},
		};

		this.data = await fetch(`https://api.reviews.co.uk/reviews?store=${this.store}&sku=${this.sku}&per_page=0`, options)
			.then((response) => response.json())
			.catch((error) => {
				console.error('Error:', error);
			});
		this.render();
	}
	get sku() {
		return this.getAttribute('sku');
	}
	get store() {
		return this.getAttribute('store');
	}
	render() {
		if (!this.data) {
			return;
		}
		const storeRating = parseFloat(this.data.average_rating);
		const storeCount = this.data.review_count;
		this.updateStoreStats(storeRating, storeCount);
	}
	updateStoreStats(stars, count) {
		this.storeStars = this.querySelector('[data-store-stars]');
		this.storeInfo = this.querySelector('[data-store-info]');
		this.storeAverage = this.querySelector('[data-store-average]');
		this.storeCount = this.querySelector('[data-store-count]');
		if (this.storeStars) {
			this.storeStars.innerHTML = this.generateStarIcons(stars);
		}
		if (this.storeInfo) {
			this.storeInfo.innerHTML = window.themeVariables.strings.reviewsIoInfo
				.replace('[RATING]', stars.toFixed(1))
				.replace('[COUNT]', this.formatNumber(count));
		}
		if (this.storeAverage) {
			const decimal = parseInt(this.storeAverage.getAttribute('data-store-average')) || 2;
			this.storeAverage.innerHTML = stars.toFixed(decimal).replace('.', ',');
		}
		if (this.storeCount) {
			this.storeCount.innerHTML = this.formatNumber(count);
		}
	}
	formatNumber(number) {
		return new Intl.NumberFormat('de-DE').format(number);
	}
	generateStarIcons(rating) {
		const { fullStar, halfStar, emptyStar } = window.themeVariables.svgs;

		let filledStars = '';
		let emptyStars = '';
		let fullStars = Math.floor(rating);
		let partialStar = rating - fullStars;

		filledStars = fullStar.repeat(fullStars);

		if (partialStar > 0) {
			if (partialStar <= 0.7) {
				filledStars += halfStar;
			} else {
				filledStars += fullStar;
			}
			fullStars += 1;
		}

		emptyStars = emptyStar.repeat(5 - fullStars);

		return filledStars + emptyStars;
	}
}

if (!window.customElements.get('reviews-io-store-stats')) {
	window.customElements.define('reviews-io-store-stats', ReviewsIoStoreStats);
}
